import React from "react"
import { PrimaryLeftImageRightHeadingTextButtonType } from "../../types/mainModulTypes"
import PrimaryButton from "../common/PrimaryButton"
import { API } from "../../constants/constants"
import { useNavigate } from "react-router-dom"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"
import rainbow from "../../assets/rainbow-people.png"

export default function PrimaryLeftImageRightHeadingTextButton(props: PrimaryLeftImageRightHeadingTextButtonType) {
    const navigate = useNavigate()

    return (
        <div className="max-w-content mx-auto flex flex-col gap-6 items-center px-4 lg:px-0">
            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8">
                <img
                    src={API + props?.primaryLeftImageRightHeadingTextButtonImage?.url}
                    alt={props.primaryLeftImageRightHeadingTextButtonImage?.description ?? props.primaryLeftImageRightHeadingTextButtonImage?.name}
                    className="sm:w-5/12 w-full aspect-video sm:aspect-[10/9] object-cover rounded-default border-4 border-accent"
                />
                <div className="border-x-4 border-transparent sm:border-none">
                    <BaseSubheadline label={props.primaryLeftImageRightHeadingTextButtonHeading} />
                    <BaseRichtext content={props.primaryLeftImageRightHeadingTextButtonText} classProps="pt-2 sm:pt-4 pb-2 sm:pb-6" />
                    <PrimaryButton
                        active
                        text={props?.primaryLeftImageRightHeadingTextButtonButton}
                        onClick={() => {
                            if (props.primaryLeftImageRightHeadingTextButtonUrl.includes("https://")) {
                                window.open(props.primaryLeftImageRightHeadingTextButtonUrl, "_blank")
                            } else {
                                navigate(props.primaryLeftImageRightHeadingTextButtonUrl)
                            }
                        }}
                        classProps="w-full sm:w-fit"
                    />
                </div>
            </div>
            {/* TODO Alt Tag & SRC?? */}
            <img src={rainbow} alt="Regenbogen Icon" className="w-full mx-auto" />
        </div>
    )
}
